import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class Banco extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'banco/one', saveUrl: 'banco/save', backUrl: '/Catalogo/Bancos' },
      new Form([
        Form.Field('text', 'banco', 'Banco', '', [Validators.required], 2),
        Form.Field('text', 'banco_nombre', 'Nombre', '', [Validators.required], 5),
        Form.Field('text', 'banco_cvesat', 'Clave Sat', '', [Validators.required], 5),
        Form.Field('text', 'banco_ncorto', 'Nombre Corto', '', [Validators.required], 6),
        Form.Field('text', 'banco_rsocial', 'Razon Social', '', [Validators.required], 6),
        Form.Field('text', 'banco_rfc', 'RFC', '', [Validators.required], 12),
      ], ['Guardar'], 'Banco'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 mb-6">
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Banco)
